export default "__VITE_ASSET__cc37a38f__"